
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";
import { Admin } from "@/models/admin";
import { AdminsService } from "@/services/admins-service";
import { Department, getDepartmentName } from "@/utils/department";

export default Vue.extend({
	data() {
		return {
			admins: [] as Admin[],
			items: [] as ISelectItem<Admin | Department>[]
		};
	},
	props: {
		label: String,
		value: Array as () => Admin[],
		fancy: Boolean
	},
	watch: {
		value: {
			immediate: true,
			handler() {
				this.updateValues();
				this.updateItems();
			}
		},
	},
	methods: {
		onInput(event:(Admin | number)[]) {
			let admins = [] as Admin[];
			admins.push(...(event.filter((f:any) => typeof(f) == "object") as any as Admin[]));

			event.filter(f => typeof(f) == "number").forEach((d:Admin | Department) => {
				let dep = d as any as Department;
				let addAdmins = this.admins.filter(a => a.isInDepartment(dep));
				admins.push(...addAdmins);
			});

			admins = admins.filter((a, i) => admins.findIndex(a2 => a2.id == a.id) == i);
			this.$emit("input", admins);
		},
		updateItems() {
			this.items = this.admins.map(a => {
				return {
					text: a.email,
					value: a
				};
			});

			this.items.push(...([
				Department.Secretariaat,
				Department.Sales,
				Department.TechnischeDienst,
				Department.DevWfShopOrOnline,
				Department.Programmatie,
				Department.Marketing,
				Department.Servicepakket,
				Department.Overzetting,
				Department.Boekhoudportaal
			].map(d => {
				return {
					text: getDepartmentName(d),
					value: d
				};
			})));
		},
		updateValues() {
			for (let admin of this.admins) {
				let index = this.value.findIndex(a => a.id == admin.id);
				if (index != -1) {
					this.value[index] = admin;
				}
			}
		}
	},
	async created() {
		this.admins = await AdminsService.getAdmins();
		this.updateValues();
		this.updateItems();
	}
});
